import { toast } from 'react-toastify';
import { useAPI } from 'src/hooks';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Spinner from '@com/utils/Spinner';
import loadable from '@loadable/component';

const Footer = loadable(() => import('@com/footer/Footer'));
const FullSectionText = loadable(() => import('@com/FullSectionText'));
const Header = loadable(() => import('@com/header/Header'));
const TopSection = loadable(() => import('@com/TopSection'));

function EmailVerification() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t, ready } = useTranslation();
  const { verifyAccount } = useAPI();

  const uuid = searchParams.get('u');
  const oneTimeKey = searchParams.get('k');

  useEffect(() => {
    (async () => {
      if (uuid && oneTimeKey && ready) {
        const isSuccess = await verifyAccount(uuid, oneTimeKey);
        if (isSuccess) {
          toast.info(t('toastMessage.emailVerifySucceed'));
        } else {
          toast.error(t('toastMessage.emailVerifyFailed'));
        }
        navigate('/');
      }
    })();
  }, [ready]);

  return (
    <>
      <Header />
      <TopSection sectionName={t('header.emailVerification')} />
      <FullSectionText>
        <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column align-items-center">
            <Spinner height={256} width={256} />
          </div>
        </div>
      </FullSectionText>
      <Footer />
    </>
  );
}

export default EmailVerification;
